import {
    createCopyLink,
    decodeDeeplink,
    formatDate,
    generateUUID2,
    getFileNameWithoutExt,
    getNoteDocThumbHtml,
    getSafeInt,
    getSafeString,
    isAnnoType,
    isArray,
    isBilibiliUrl,
    isCardEmpty,
    isDarkMode,
    isDeepLink,
    isStringNullOrEmpty,
    isSupportVideoAnnoUrl,
    logger,
    removeHtmlTags
} from "@/utils";
import {isWebApp} from "@/electron_interactive";
import {apiLibraryDelete, apiLibraryDetail, apiLibraryList, apiLibraryUpdate} from "@/api/AppXhrRequest";
import {postMessage} from "@/common/event";
import {
    EVENT_REFRESH_ANNO_NAME,
    EVENT_REFRESH_HIGHLIGHT_LIST,
    EVENT_REFRESH_LIBRARY_LIST,
    FILTER_NO_TAGS_NO_TAGS_______,
    FROM_TRASH,
    highlightDarkColorToLight,
    IMPORT_FILE_MODE_IMPORTMODE,
    KEY_CARD_ORDER_BY,
    KEY_CARD_SORT_TYPE,
    KEY_SHOW_HIDIN_CARDS,
    MAP_HIGHLIGHT_COLOR_D_2_L,
    MAP_HIGHLIGHT_COLOR_L_2_D,
    PAGE_SIZE
} from "@/Const";
import global from "@/global";
import {ipcInvoke} from "@/common/ipc";
import {updateHistory} from "@model/libraryHistory";
import {dbGetHighlight, updateHighlight} from "@model/highlight";
import {apiBilibiliCover} from "@/api/ThirdApi";
import {imgServer} from "@/components/EditorV2/imgServer";
import library from "../@excalidraw/packages/excalidraw/data/library";
import {getPublishProjectList, getTextElementCount} from "@model/note";
import {getLinkFavorList} from "@model/link";

let mDb:any;
let mCard:any;
let mCardDoc:any;
let lastUpdateCardTime:any = 0;
let mLastCardId:string = '';
let mLastLibraryKey = '';
let mLibraryListCache = {
    isDeleted:0,
    types:'',
    tags:'',
    searchKey:'',
    arrayCardList:[]
}

/**
 * id,name,doc,type,thumbHtml
 * @param db
 */
export function initCard(db){
    mDb = db;
    mCard = db.table('card');
    mCardDoc = db.table('cardDoc');
}

function isCardAllEqual(card0:any,card1:any){
    return card0.doc == card1.doc &&
        card0.name == card1.name &&
        card0.isDeleted == card1.isDeleted &&
        card0.isFavirated == card1.isFavirated &&
        card0.isHidden == card1.isHidden &&
        card0.comment == card1.comment &&
        card0.text == card1.text &&
        card0.thumbImage == card1.thumbImage &&
        JSON.stringify(card0.tags) == JSON.stringify(card1.tags);
}

function isCardEqualNoDoc(card0:any,card1:any){
    return card0.name == card1.name &&
        card0.isDeleted == card1.isDeleted &&
        card0.isFavirated == card1.isFavirated &&
        card0.isHidden == card1.isHidden &&
        card0.comment == card1.comment &&
        card0.text == card1.text &&
        card0.thumbImage == card1.thumbImage &&
        JSON.stringify(card0.tags) == JSON.stringify(card1.tags);
}

/**
 * 根据id重命名元素...
 * @param szId
 * @param szNewName
 */
export async function renameCardById(szId:any,szNewName:any){
    if (!szId)return;
    const library = await getCardById(szId);
    if (library){
        library.name = szNewName || '';
        await renameCard(library);
    }

    //更新highlight--如果有的话
    const highlight = await dbGetHighlight(szId);
    if (highlight){
        highlight.name = szNewName || '';
        await updateHighlight(highlight);
    }
}

/**
 * 更新source..........
 * @param szId
 * @param szNewSource
 */
export async function updateChangeSource(szId:any,szNewSource:any){
    if (!szId)return;
    let library:any = await getCardById(szId);
    let szNewFileName = szNewSource;
    if (!library){
        ////条目被删除，然后又从回收站中清空了。然后又来更改标注的source ????
        const data = await window.importFileToLibraryWithReturn({name:getFileNameWithoutExt(szNewSource),path:szNewSource},IMPORT_FILE_MODE_IMPORTMODE,false);
        data.isDeleted = 0;
        data.id = szId;
        await updateCard(data);
        library = data;
        //如果highlight有,也更新..
        // const highlight = await dbGetHighlight(szId);
        // highlight.isDeleted = 0;
        // await updateHighlight(highlight);
    }
    if (!library.isAbsolutePath){
        szNewFileName = await ipcInvoke('copy-file',{filePath: szNewSource,forceRename:true})
    }
    // library.isAbsolutePath = true;
    library.fileName = szNewFileName;
    await updateCard(library);
    const highlight = await dbGetHighlight(szId);
    if (highlight){
        highlight.isDeleted = 0;
        // highlight.isAbsolutePath = true;
        highlight.thumbImage = library.thumbImage;
        highlight.fileName = szNewFileName;
        await updateHighlight(highlight);
    }
    return szNewFileName;
}

/**
 * 更新source..........
 * @param szId
 * @param szNewSource
 */
export async function updateChangeSourceVideo(szId:any,newData:any){
    if (!szId)return;
    const library:any = await getCardById(szId);
    // library.isAbsolutePath = true;
    library.fileName = newData.fileName;

    if (newData.name){
        library.name = newData.name;
    }
    library.isAbsolutePath = newData.isAbsolutePath;
    if (newData.thumbImage){
        library.thumbImage = newData.thumbImage;
    }
    if (newData.type){
        library.type = newData.type;
    }


    await updateCard(library);
    const highlight = await dbGetHighlight(szId);
    if (highlight){
        highlight.isAbsolutePath = library.isAbsolutePath;
        highlight.fileName = highlight.url = library.fileName;
        highlight.thumbImage = library.thumbImage;
        highlight.name = library.name;
        highlight.type = library.type;
        await updateHighlight(highlight);
    }

    //更新anno的名称
    await renameAnno(library);

    if (isBilibiliUrl(newData.fileName)){
        //再更新一次.....
        apiBilibiliCover(newData.fileName).then(async (res)=>{
            if (res){
                library.name = res.title;
                library.thumbImage = res.pic;
                await updateCard(library);

                if (highlight){
                    highlight.name = res.title;
                    highlight.thumbImage = res.pic;
                    await updateHighlight(highlight);
                }

                //更新anno的名称
                await renameAnno(library);

                postMessage(EVENT_REFRESH_LIBRARY_LIST);
            }
        })
    }
    return library;
}


/**
 * 更新source..........
 * 又一个.
 * @param szId
 * @param szNewSource
 */
export async function updateChangeSourcePdfAudio20260126(szId:any,newData:any){
    if (!szId)return;
    const library:any = await getCardById(szId);
    // library.isAbsolutePath = true;
    library.fileName = newData.fileName;
    library.libraryId = newData.id;

    if (newData.name){
        library.name = newData.name;
    }
    library.isAbsolutePath = newData.isAbsolutePath;

    await updateCard(library);
    const highlight = await dbGetHighlight(newData.id);
    if (highlight){
        highlight.isAbsolutePath = library.isAbsolutePath;
        highlight.fileName = highlight.url = library.fileName;
        highlight.thumbImage = library.thumbImage;
        highlight.name = library.name;
        highlight.type = library.type;
        await updateHighlight(highlight);
    }

    //更新anno的名称
    // await renameAnno(newData);

    return library;
}

/**
 * 更新anno的名称
 * @param newCard
 */
export async function renameAnno(newCard:any){
    const arrayLibs = await getCardListByLibraryId(newCard.id);
    for (let i=0;i<arrayLibs.length;i++){
        const item = arrayLibs[i];
        item.name = newCard.name;
        await updateCard(item,false);
    }
}

/**
 * 重命名library---
 * 下面的都要重命名
 * @param newCard
 */
export async function renameCard(newCard:any){
    if (newCard.hasTitle == false){
        if (!newCard.doc){
            newCard.doc = await getCardDoc(newCard.id);
        }
        //取第一个html,如果是h1,那么就set
        const parser = new DOMParser();
        const doc = parser.parseFromString(newCard.doc,'text/html');
        if(doc.body.firstElementChild?.className == 'heading-container'){
            const arrayH1 = doc.body.firstElementChild.getElementsByTagName('h1');
            if (arrayH1 && arrayH1.length >0){
                const h1 = arrayH1[0];
                h1.innerText = newCard.name;

                // 3. 使用 XMLSerializer 将 DOM 元素转回字符串
                newCard.doc = doc.body.innerHTML;
            }
        }else{
            //添加一个h1
            const szTitle = `<div class="heading-container" id="${generateUUID2()}"><img class="heading-image" src="./imgs/arrowBottom.svg" alt="heading image"><h1 id="${generateUUID2()}" data-fold="false" ifhidden="false">${newCard.name}</h1></div>`
            newCard.doc = szTitle + newCard.doc;
        }
        // newCard.name = '';//不要置空了，重命名的正好取这个...
    }
    await updateCard(newCard);
    // if (newCard.type == 'pdf' || newCard.type == 'video' || isSupportVideoAnnoUrl(newCard.fileName))
    {
        const arrayLibs = await getCardListByLibraryId(newCard.id);
        for (let i=0;i<arrayLibs.length;i++){
            const item = arrayLibs[i];
            item.name = newCard.name;
            await updateCard(item,false);
            postMessage(EVENT_REFRESH_ANNO_NAME,{...item})
        }
    }

    //更新highlight--如果有的话
    const highlight = await dbGetHighlight(newCard.id);
    if (highlight){
        highlight.name = newCard.name || '';
        await updateHighlight(highlight);
    }
}

/**
 * 批量更新card的标注内容
 * @param arrayHighlights
 * @param szCardId
 */
export async function batchCardHighlight(arrayHighlights:any,szCardId:any,szTitle:any){
    const arrayNewForDb:any = [];
    const arrayDb = await getCardListByLibraryId(szCardId);

    for (let i=0;i<arrayHighlights.length;i++){
        const high = arrayHighlights[i];
        const dbLibrary = await getCardById(high.id,false);
        let newItem = {...high};
        newItem.type = 'cardAnno';
        newItem.name = szTitle || '';
        newItem.annoType = 'highlight';
        if (high.type == 'image'){
            newItem.image = newItem.content;
            newItem.thumbImage = newItem.content;
            newItem.annoType = 'image';
        }else{
            newItem.text = newItem.content || '';
            if (!newItem.text)continue;
        }

        newItem.comment = newItem.noteText || '';
        newItem.libraryId = szCardId;
        newItem.isDeleted = 0;
        if (dbLibrary){
            newItem.createTime = dbLibrary.createTime;
            newItem.updateTime = dbLibrary.updateTime;
            newItem.tags = dbLibrary.tags;
            newItem.infoNotes = dbLibrary.infoNotes;
            newItem.infoUrl = dbLibrary.infoUrl;
        }else{
            newItem.createTime = newItem.updateTime = Date.now();
        }

        //color转换为浅色模式下的color;!!!
        newItem.color = highlightDarkColorToLight(newItem.color);

        delete newItem.noteText;
        delete newItem.node;
        delete newItem.content;
        arrayNewForDb.push(newItem);
    }
    await batchUpdateCard(arrayNewForDb);

    //删除没有的
    for (let i=0;i<arrayDb.length;i++){
        const isExist = arrayHighlights.some(p=>p.id == arrayDb[i].id);
        if (!isExist){
            await deleteCard(arrayDb[i].id);
        }
    }
}


/**
 * 批量更新...
 * @param arrayCards
 */
export async function batchUpdateCard(arrayCards:any){
    return mCard.bulkPut(arrayCards);
}


/**
 * 更新最近打开的view
 * @param szId
 */
export function updateLastView(szId:any,bRefreshList){
    if (!szId)return;
    getCardById(szId).then(res=>{
        if (res){
            res.viewTime = Date.now();
            updateCard(res).then(res=>{
                if (bRefreshList){
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    postMessage(EVENT_REFRESH_HIGHLIGHT_LIST);
                }
            })
        }
    });
    dbGetHighlight(szId).then(res=>{
        if (res){
            res.viewTime = Date.now();
            updateHighlight(res).then(res=>{
                if (bRefreshList){
                    postMessage(EVENT_REFRESH_HIGHLIGHT_LIST)
                }
            });
        }
    })
}

export async function updateCard(card:any,isUpdateTime:boolean = true,hasUpdateRef:boolean = true,from:any='',bAllowEmptyDoc=false){
    if (global.g_isPresentMode)return card;

    global.g_isCardUpdate = false;

    if (!card)return {};

    //记录一下。。。
    // console.log('update card start...');

    // if (mLastCardId == card.id && Date.now() - lastUpdateCardTime < 800){
    //     return;
    // }

    /***这里一些补救措施。。。。。****/
    card.id = ''+card.id;
    if (card.type == 'note'){
        card.type = 'card';
    }
    /****补救结束，能救活*****/

    mLastCardId = card.id;

    //是否有修改
    /*
    const dbCard:any = await getCardById(card.id);
    if (dbCard){
        if (!card.doc){
            if (isCardEqualNoDoc(dbCard,card)){
                // isUpdateTime = false;
                //只更新viewTime
                // dbCard.viewTime = Date.now();
                if (dbCard.type == 'card' || dbCard.type == 'journal'){
                    dbCard.thumbHtml = getNoteDocThumbHtml(dbCard.doc);
                }
                dbCard.sort = card.sort;
                dbCard.doc = '';
                await mCard.put(dbCard);
                return;
            }
        }
        //没有改动....
        if (isCardAllEqual(dbCard,card)){
            // isUpdateTime = false;
            // dbCard.viewTime = Date.now();
            if (dbCard.type == 'card' || dbCard.type == 'journal'){
                dbCard.thumbHtml = getNoteDocThumbHtml(dbCard.doc);
            }

            dbCard.doc = '';
            await mCard.put(dbCard);
            return;
        }
    }*/
    global.g_isCardUpdate = true;

    lastUpdateCardTime = Date.now();

    //删除临时的这个属性
    // delete card.isChecked;
    delete card.isHover;
    delete card.isChecked;
    delete card.isSelected;
    delete card.annoId;
    delete card.isPin;
    delete card.isEmpty;

    if (!card.createTime){
        card.createTime = Date.now();
    }
    if ((Date.now() - card.createTime) < 2000){
        //是新创建的卡片.---这里是因为，有些地方要变列表，有时候不变。有时候变....不好说...
        if (global.g_mArrayOriginSort && Object.keys(global.g_mArrayOriginSort).length > 0){
            global.g_mArrayOriginSort[card.id] = 0;
        }
    }
    //查看时间随时更新...
    // card.viewTime = Date.now();

    if ((card.type == 'card' || card.type == 'journal')){
        //要比较原始的内容，从数据库取，---
        const dbCard:any = await getCardById(card.id);
        if (!card.doc && !bAllowEmptyDoc){
            if (dbCard){
                card.thumbHtml = getNoteDocThumbHtml(dbCard.doc);
                card.doc = dbCard.doc;
            }
        }else{
            if (card.doc){
                card.thumbHtml = getNoteDocThumbHtml(card.doc);
            }
        }

        //以新的更新时间记录....--旧的当成viewTime了，不能更改了....
        if (dbCard){
            if (dbCard.isDeleted == 1 && from != FROM_TRASH){
                card.isDeleted = 1;
            }
            card.createTime = dbCard.createTime;
            if (card.isFavirated == undefined){
                card.isFavirated = dbCard.isFavirated;
                card.favirateTime = dbCard.favirateTime;
            }
            if (card.viewTime == undefined){
                card.viewTime = dbCard.viewTime;
            }
            if(card.doc != dbCard?.doc || card.name != dbCard?.name){
                card.updateTime1 = Date.now();
            }else{
                card.updateTime1 = (dbCard.updateTime1 || dbCard.updateTime);
            }
            //patch---patch
            if (card.infoNotes == undefined){
                card.infoNotes = dbCard.infoNotes;
            }
            if (card.infoUrl == undefined){
                card.infoUrl = dbCard.infoUrl;
            }
        }else{
            card.updateTime1 = Date.now();
        }


        if (card.type == 'journal'){
            if (isCardEmpty(card.doc)){
                card.isDeleted = 1;
            }else{
                card.isDeleted = 0;
            }
        }
        //判断一下，如果doc有更新，才更新updateTime,否则不变.
        // const dbCard:any = await getCardById(card.id);
        // if (dbCard){
        //     if (removeHtmlTags(card.doc) == removeHtmlTags(dbCard.doc)){
        //         card.updateTime = dbCard.updateTime;
        //     }
        // }
    }



    if (!card.isDeleted){
        card.isDeleted = 0;
    }

    if (isUpdateTime){
        card.updateTime = Date.now();
    }

    // card.viewTime = Date.now();

    let szDoc = card.doc;
    if (szDoc && isDarkMode()){
        //转成浅色
        const arrayHighKeys = Object.keys(MAP_HIGHLIGHT_COLOR_D_2_L);
        arrayHighKeys.forEach(p=>{
            szDoc = szDoc.replaceAll(p,MAP_HIGHLIGHT_COLOR_D_2_L[p]);
        })
    }
    let cardDoc = {
        id:card.id,
        doc:szDoc
    }
    card.doc = '';
    await mCard.put(card);
    if ((card.type == 'card' || card.type == 'journal') && cardDoc.doc){
        //doc 有实际的html内容才更新
        await mCardDoc.put(cardDoc);
        if (hasUpdateRef){
            //更新引用...
            // updateCardRef(szCardName,card);
        }

        //更新到历史记录.....--最新的一个历史记录与当前时间比较.
        updateHistory(card,cardDoc.doc);
    }

    //region webapp--
    if (isWebApp()){
        var newCard = {
            ...card,
            doc:cardDoc.doc
        }
        //更新到服务端--不能写下面的这句？？？？？？？
        // apiProjectList()
        apiLibraryUpdate(newCard).then(res=>{
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
        });
    }
    //endregion

    card.doc = cardDoc.doc;

    // console.log('update note finished.....')

    return card;
}



/**
 * 更新查看时间
 * @param szId
 */
export function updateCardViewTime(szId:any){
    return new Promise(async (resolve) => {
        const card = await mCard.get(szId);
        if (card){
            card.viewTime = Date.now();
            mCard.put(card);
            resolve('ok');
        }
    })
}

/**
 * 更新这个card 在别的项目中的引用，标题或第一行....
 * @param card
 */
async function  updateCardRef(title:any,card:any){
    const arrayCards:any = await getCardList(-1,0,'card','','');
    let szImage = 'deeplink_card.png';
    for (let i=0;i<arrayCards.length;i++){
        const item = arrayCards[i];
        if (item.id == card.id)continue;
        item.doc = await getCardDoc(item.id);
        let pattern = /<deeplink(.*?)<\/deeplink>/g;
        let results = item.doc.match(pattern);
        if (results){
            const parser = new DOMParser();
            for (let i=0;i<results.length;i++){
                //获取标题和链接
                const szStr = results[i];
                const xmlDoc = parser.parseFromString(szStr,'text/xml');
                const deeplinkTag = xmlDoc.getElementsByTagName('deeplink')[0];
                if (deeplinkTag){
                    const szName = deeplinkTag.getAttribute('text');
                    const szHref:any = deeplinkTag.getAttribute('href');

                    const deeplink = decodeDeeplink(szHref);
                    if (deeplink.childType == 'card' && deeplink.id == card.id){
                        //把这个换成新的...
                        if (deeplink.childId){
                            //子block.....-----这里要重置。。
                        }else{
                            let szDeeplink = createCopyLink('library',card.id,'card',null,null,null,false);
                            item.doc = item.doc.replaceAll(szStr,`<deeplink href="${szDeeplink}" text="${title}" image="${szImage}"></deeplink>`);
                        }

                    }
                }
            }
            //更新这个card
            updateCard(item,false,false);
        }
    }
}


/**
 * 获取card 全量的数据
 * @param id
 */
export async function getCardById(id:any,hasDoc:boolean = true){
    if (!id)return (null);
    return new Promise(async (resolve, reject) => {
        const card = await mCard.get(id);
        if (card && hasDoc && (card.type == 'card' || card.type == 'journal' || card.type == 'note')){
            card.doc = await getCardDoc(id);
        }
        resolve(card);
    })
}

export async function getCardByIds(arrayIds:any){
    return mCard.bulkGet(arrayIds);
}

export async function getCardDocByIds(arrayCardIds:any){
    return mCardDoc.bulkGet(arrayCardIds);
}

/**
 * 根据文件名称判断是否库中已存在，如果不存在添加到库中，如果存在就用这个.
 * @param szFileName
 */
export async function getLibraryByFileName(szFileName:any){
    const array = await mCard.toArray();
    return array.find(p=>p.fileName == szFileName && p.isDeleted == 0);
}

/**
 * 获取所有子项目
 * @param libraryId
 */
export async function getCardListByLibraryId(libraryId:any){
    if (!libraryId){
        return [];
    }
    const arrayDatas = await mCard.where({libraryId:libraryId}).toArray();
    return arrayDatas.filter(p=>p.isDeleted == 0);
}

export async function getJournalByFormatDate(date:any){
    const szDate = formatDate(date,'yyyyMMdd');
    let arrayCards = await mCard.where({type:'journal','formatDate':szDate}).toArray();
    //按更新时间排序，找最新的一个..
    let card = null;
    if (arrayCards.length > 0){
        arrayCards = arrayCards.sort(function (a,b){
            return b.updateTime - a.updateTime;
        });
        card = arrayCards[0];
        if (card &&  card.type == 'journal'){
            card.doc = await getCardDoc(card.id);
            if (card.isDeleted == 1){
                card = null;
            }
        }
    }

    return card;
}

/**
 * 该日期下是否有
 * @param date
 */
export async function getJournalByFormatDateExist(date:any){
    const szDate = formatDate(date,'yyyyMMdd');
    const card = await mCard.where({type:'journal','formatDate':szDate}).first();
    return card && card.isDeleted != 1;
}

export function getCardDocList(){
    return mCardDoc.toArray();
}

/**
 * 根据ID获取DOC
 * @param id
 */
export function getCardDoc(id:string){
    if (!id)return null;

    return new Promise((resolve, reject) => {
        if (isWebApp()){
            apiLibraryDetail(id).then(res=>{
              resolve(res.doc);
            }).catch(e=>{
                resolve('')
            })
        }else{
            mCardDoc.get(id).then(res=>{
                if (res){
                    let szDoc = res.doc || '';
                    if (isDarkMode()){
                        //------浅色转深色------
                        const arrayHighKeys = Object.keys(MAP_HIGHLIGHT_COLOR_L_2_D);
                        arrayHighKeys.forEach(p=>{
                            szDoc = szDoc.replaceAll(p,MAP_HIGHLIGHT_COLOR_L_2_D[p])
                        })
                    }else{
                        //这里多一个转换...
                        const arrayHighKeys = Object.keys(MAP_HIGHLIGHT_COLOR_D_2_L);
                        arrayHighKeys.forEach(p=>{
                            szDoc = szDoc.replaceAll(p,MAP_HIGHLIGHT_COLOR_D_2_L[p])
                        })
                    }
                    //转换arrow
                    // if (isDarkMode()){
                    //     szDoc = szDoc.replaceAll('src="./imgs/arrowBottom.svg"','src="./imgs/arrowBottom_white.svg"')
                    // }else{
                    //     szDoc = szDoc.replaceAll('src="./imgs/arrowBottom_white.svg"','src="./imgs/arrowBottom.svg"')
                    // }

                    resolve(szDoc);
                }else{
                    resolve('');
                }
            }).catch(e=>{
                resolve('')
            });
        }
    })
}

/**
 * 只保存doc...不行...!!!
 * @param id
 * @param doc
 */
// export function updateCardDoc(id,doc){
//     return mCardDoc.put({id,doc})
// }

/**
 * 取已删除的..
 */
export function getDeletedCardList(){
    return mCard.where('isDeleted').equals(1).toArray();
}

/**
 * 带搜索的全部....
 * @param searchKey
 */
export function getAllCardList(searchKey:any = ''){
    return new Promise(async (resolve) => {
        let arrayResult = await mCard.where('isDeleted').equals(0).toArray();
        if (searchKey){
            searchKey = searchKey.toLowerCase();
            var arrayNewResult = [];
            for (let i=0;i<arrayResult.length;i++){
                const card = arrayResult[i];
                if (card.type == 'row')continue;

                let szCardName = getSafeString(card.name)
                if (szCardName && szCardName.toLowerCase().indexOf(searchKey) != -1){
                    arrayNewResult.push(card);
                    continue;
                }
                let szInfoNotes = getSafeString(card.infoNotes);
                if (szInfoNotes?.toLowerCase()?.includes(searchKey)){
                    arrayNewResult.push(card);
                    continue;
                }

                if (card.type == 'card' || card.type == 'journal'){
                    let szHtml:any = await getCardDoc(card.id);
                    if (szHtml){
                        szHtml = removeHtmlTags(szHtml);
                        if (szHtml.toLowerCase().indexOf(searchKey) != -1){
                            arrayNewResult.push(card);
                        }
                    }
                }else if (card.type == 'pdfAnno'){
                    if (getSafeString(card.comment)?.toLowerCase()?.includes(searchKey) || getSafeString(card.text)?.toLowerCase()?.includes(searchKey)){
                        arrayNewResult.push(card);
                    }
                }else if (card.type == 'videoAnno'){
                    if (getSafeString(card.content)?.toLowerCase()?.includes(searchKey) || getSafeString(card.title)?.toLowerCase()?.includes(searchKey)){
                        arrayNewResult.push(card);
                    }
                }else if (card.type == 'cardAnno'){
                    if (getSafeString(card.text)?.toLowerCase()?.includes(searchKey) || getSafeString(card.comment)?.toLowerCase()?.includes(searchKey)){
                        arrayNewResult.push(card);
                    }
                }
            }
            arrayResult = arrayNewResult;
        }
        resolve(arrayResult);
    })
}

/**
 * 统计库列表tagName
 * @param szTagName
 */
export function statusCardListByTagsName(szTagName:any){
    return mCard.where('tags').equals(szTagName).filter(p=>p.isDeleted == 0).count();
}

export function isCardExistInDb(id:string){
    return new Promise(async (resolve, reject)=>{
        const card = await mCard.get(id);
        resolve(card != null && card != undefined);
    })
}

/**
 * 空白卡片的数量
 */
export function getEmptyCardCount(){
    return new Promise(resolve => {
        mCard.where({'type': 'card'}).toArray().then(async (res) => {
            let nCount = 0;
            for (let i = 0; i < res.length; i++) {
                const doc: any = await getCardDoc(res[i].id);
                if (!res[i].name && isCardEmpty(doc)) {
                    nCount ++;
                }
            }
            resolve(nCount);
        })
    })
}

export function deleteEmptyCards(){
    return new Promise((resolve, reject) => {
        mCard.where({'type':'card'}).toArray().then(async (res)=>{
            for (let i=0;i<res.length;i++){
                const doc:any = await getCardDoc(res[i].id);
                if (!res[i].name && isCardEmpty(doc)){
                    await mCard.delete(res[i].id);
                }
            }
            resolve('ok');
        });
    })

}

/**
 * card数量
 */
export function getCardCount(){
    return new Promise(async (resolve) => {
        let nCount = await mCard.where({'type':'card',"isDeleted":0}).count();
        let nBoardText = await getTextElementCount('');
        resolve(nCount + nBoardText);
    })
}
/**
 * 获取库中视频数量
 */
export function getLibraryVideoCount(){
    return mCard.where({'type':'video',"isDeleted":0}).count();
}

/**
 * 获取库中视频数量
 */
export function getLibraryPdfCount(){
    return mCard.where({'type':'pdf',"isDeleted":0}).count();
}

export function deleteCard(id:any){
    if (!id)return null;
    if (isWebApp()){
        mCardDoc.delete(id);
        mCard.delete(id);
        return apiLibraryDelete(id);
    }


    //缩略图
    ipcInvoke('delete-files-file',{fileName:id+'.png'});
    //删除文件。。
    getCardById(id,true)?.then((res:any)=>{
        if (res?.fileName){
            ipcInvoke('delete-files-file',{fileName:res.fileName})
        }
        if (res?.thumbImage){
            ipcInvoke('delete-files-file',{fileName:res.thumbImage})
        }
        if (res?.doc){
            imgServer.getImgFromSystem(res.doc).then(arrayImgs=>{
               arrayImgs.forEach(p=>{
                   // ipcInvoke('delete-files-file',{fileName:p.id+'.'+p.ext});
                   let szFileName = p.id+'.'+p.ext;
                   removeCardImage(szFileName,id);
               })
            });
        }

        mCardDoc.delete(id);
    });

    return mCard.delete(id);
}

/**
 * 移除卡片中的图片...
 * @param szFileName
 */
export function removeCardImage(szFileName:any,id:any = null){
    //全局查询下是否有别的卡片引用这个...
    getCardDocList().then(arrayDocs=>{
        const reg = new RegExp(szFileName,'gi');
        let bFind = false;
        for (let i=0;i<arrayDocs.length;i++){
            if (id == arrayDocs[i].id)continue;
            const doc = arrayDocs[i].doc;
            const matchs = doc.match(reg);
            if (matchs && matchs.length > 0){
                bFind = true;
                break;
            }
        }
        if (!bFind){
            ipcInvoke('delete-files-file',{fileName:szFileName});
        }
    })
}

/**
 * 只取card
 */
export function getLibraryRecentsList(){
   return mCard.orderBy('viewTime').desc().filter(p=>p.isDeleted == 0 && p.type == 'card').offset(0).limit(20).toArray();
}

/**
 * 根据libraryid 查询
 * @param szLibraryId
 */
export function getLibraryByLibraryId(szLibraryId:any){
    return mCard.where({'libraryId':szLibraryId}).toArray();
}


/**
 * 根据选择的类型，查询所有source.
 * @param arraySelectTypes
 */
export function getSourceByAnnoType(arraySelectTypes:any){
    const arraySourceType:any = [];
    for (let i=0;i<arraySelectTypes.length;i++){
        if (arraySelectTypes[i].isChecked){
            if (arraySelectTypes[i].value == 'cardAnno'){
                arraySourceType.push('card');
            }
            if (arraySelectTypes[i].value == ('pdfAnno')){
                arraySourceType.push('pdf');
            }
            if (arraySelectTypes[i].value == ('videoAnno')){
                arraySourceType.push('video');
                arraySourceType.push('liveVideo');
                arraySourceType.push('bilibili');
                arraySourceType.push('youtube');
                arraySourceType.push('baidu');
            }
            if (arraySelectTypes[i].value == ('audioAnno')){
                arraySourceType.push('audio');
            }
        }
    }
    return mCard.filter(p=>p.isDeleted ==0 && arraySourceType.includes(p.type)).toArray();
}

export function getLibraryCount(nPageNum:number,isDeleted= 0,szType:string|'card'|'pdf'|'video'|'image'|'audio'|'file'|'journal'|'pdfAnno',szTagName:string,searchKey:string,isFavor = false){
    return new Promise(async (resolve, reject) => {
        const arrayTypes:any = [];
        if (!isArray(szType)){
            arrayTypes.push(szType);
        }else{
            arrayTypes.push(...szType);
        }
        if (arrayTypes.includes('liveVideo')){
            arrayTypes.push('bilibili');
            arrayTypes.push('youtube');
            arrayTypes.push('baidu');
        }
        if (isWebApp()){
            apiLibraryList(isDeleted,szType,szTagName,searchKey).then((res:any)=>{
                if (res.code == 0){
                    resolve(res.data);
                }
            })
        }else{
            // let arrayDatas = mCard.where({'type':szType,"isDeleted":isDeleted})//.sortBy('name').offset(0).limit(PAGE_SIZE);
            let arrayDatas = null;
            let isShowHiden = localStorage.getItem(KEY_SHOW_HIDIN_CARDS) == 'true';
            let nHidden = 1;
            if (isShowHiden){
                nHidden = 1;//这个值不存在。
            }

            const hiddenCondition = (p)=>{
                if (p.type == 'card'){
                    if (isShowHiden){
                        return p.isHidden == nHidden;
                    }
                    return p.isHidden != 1;
                }
                return true;
            }

            arrayDatas = mCard.filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p));

            if (szTagName){
                if (szTagName == FILTER_NO_TAGS_NO_TAGS_______){
                    arrayDatas = arrayDatas.and(item=>!item.tags || item.tags.length == 0);
                }else{
                    arrayDatas = arrayDatas.and(item=>item.tags?.includes(szTagName));
                }
            }

            let nDeeplinkFavor = 0;
            if (isFavor){
                arrayDatas = arrayDatas.filter(p=>p.isFavirated == 1);

                const arrayDeeplinkFavor = await getLinkFavorList();
                for (let i=0;i<arrayDeeplinkFavor.length;i++){
                    const item = arrayDeeplinkFavor[i];
                    if (!isDeepLink(item.url))continue;
                    const deeplink = decodeDeeplink(item.url);
                    if (deeplink.type == 'library'){
                        if (arrayDatas.filter(p=>p.id != deeplink.id)){
                            nDeeplinkFavor ++;
                        }
                    }
                }
            }

            let nCount = await arrayDatas.count();
            nCount += nDeeplinkFavor;
            resolve(nCount)
        }
    })
}


/**
 * 获取列表
 * @param nPageNum -1表示不分页
 * @param isDeleted
 * @param szType
 * @param szTagName
 * @param searchKey
 */
export function getCardList(nPageNum:number,isDeleted= 0,szType:any|'card'|'pdf'|'video'|'image'|'audio'|'file'|'journal'|'pdfAnno',szTagName:string,searchKey:string,callback?:any,isFavor:any = false,isPublished = false){
    return new Promise(async (resolve, reject) => {
        const arrayTypes:any = [];
        if (!isArray(szType)){
            arrayTypes.push(szType);
        }else{
            arrayTypes.push(...szType);
        }
        if (arrayTypes.includes('liveVideo')){
            arrayTypes.push('bilibili');
            arrayTypes.push('youtube');
            arrayTypes.push('baidu');
        }

        if (nPageNum > 0 && mLibraryListCache.isDeleted == isDeleted &&
            mLibraryListCache.types == JSON.stringify(arrayTypes) &&
        mLibraryListCache.tags == szTagName &&
        mLibraryListCache.searchKey == searchKey && mLibraryListCache.arrayCardList.length > 0){
            const arrayCacheDatas = mLibraryListCache.arrayCardList.slice(nPageNum*PAGE_SIZE,nPageNum*PAGE_SIZE+PAGE_SIZE);
            resolve(arrayCacheDatas);
            return;
        }

        mLibraryListCache.isDeleted = isDeleted;
        mLibraryListCache.types = JSON.stringify(arrayTypes);
        mLibraryListCache.tags = szTagName;
        mLibraryListCache.searchKey = searchKey;
        mLibraryListCache.arrayCardList.length = 0;

        if (isWebApp()){
            apiLibraryList(isDeleted,szType,szTagName,searchKey).then((res:any)=>{
                if (res.code == 0){
                    resolve(res.data);
                }
            })
        }else{
            // let arrayDatas = mCard.where({'type':szType,"isDeleted":isDeleted})//.sortBy('name').offset(0).limit(PAGE_SIZE);
            let arrayDatas = null;

            let szSortType = localStorage.getItem(KEY_CARD_SORT_TYPE);
            let szOrderBy = localStorage.getItem(KEY_CARD_ORDER_BY);
            let isShowHiden = localStorage.getItem(KEY_SHOW_HIDIN_CARDS) == 'true';
            let nHidden = 0;
            if (isShowHiden){
                nHidden = 1;//换成只显示隐藏的卡片.
            }

            if(!szSortType){
                szSortType = "sort by updateDate";
            }
            if(!szOrderBy){
                szOrderBy = "date desc"
            }

            const hiddenCondition = (p)=>{
                if (p.type == 'card'){
                    if (isShowHiden){
                        return p.isHidden == nHidden;
                    }
                    return p.isHidden != 1;
                }
                return true;
            }

            let arrayPublished:any = [];
            if (isPublished){
                arrayPublished = await getPublishProjectList('card');
            }

            const filterPublished = (item)=>{
                if (isPublished){
                    return arrayPublished.findIndex(p=>p.id == item?.id) != -1;
                }
                return true;
            }

            if("sort by name" === szSortType){
                if("a-z" === szOrderBy){
                    arrayDatas = mCard.orderBy('name').filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p) && filterPublished(p));
                }else if("z-a" == szOrderBy){
                    arrayDatas = mCard.orderBy('name').reverse().filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p) && filterPublished(p));
                }
            }else if("sort by createDate" == szSortType){
                if("date asc" == szOrderBy){
                    arrayDatas = mCard.orderBy('createTime').filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p) && filterPublished(p));
                }else if("date desc" == szOrderBy){
                    arrayDatas = mCard.orderBy('createTime').reverse().filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p) && filterPublished(p));
                }
            } else if("sort by updateDate" == szSortType){
                if("date asc" == szOrderBy){
                    arrayDatas = mCard.orderBy('updateTime').filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p) && filterPublished(p));
                }else if("date desc" == szOrderBy){
                    arrayDatas = mCard.orderBy('updateTime').reverse().filter(p=>arrayTypes.includes(p.type) && p.isDeleted == isDeleted && hiddenCondition(p) && filterPublished(p));
                }
            }

            if (szTagName){
                if (szTagName == FILTER_NO_TAGS_NO_TAGS_______){
                    arrayDatas = arrayDatas.and(item=>!item.tags || item.tags.length == 0);
                }else{
                    arrayDatas = arrayDatas.and(item=>item.tags?.includes(szTagName));
                }
            }

            if (isFavor){
                arrayDatas = arrayDatas.filter(p=>p.isFavirated == 1);
            }
            // if (callback && nPageNum < 1){
            //     //回调库数量 ..
            //     arrayDatas.count().then(nCount=>{
            //         callback(nCount);
            //     });
            // }

            //缓存这个全部结果集合
            // arrayDatas.toArray().then(res=>{
            //     mLibraryListCache.arrayCardList = res;
            // });

            if (nPageNum >= 0 && !searchKey){//有搜索的时候不要分页....
                arrayDatas = arrayDatas.offset(nPageNum*PAGE_SIZE).limit(PAGE_SIZE);
            }

            let arrayResult = await arrayDatas.toArray();
            if (isFavor){
                //取deeplink类型的.---各种地方的数据需要混着。
                const arrayDeeplinkFavor = await getLinkFavorList();
                const arrayLibraryIds = [];
                for (let i=0;i<arrayDeeplinkFavor.length;i++){
                    const item = arrayDeeplinkFavor[i];
                    if (!isDeepLink(item.url))continue;
                    const deeplink = decodeDeeplink(item.url);
                    if (deeplink.type == 'library'){
                        arrayLibraryIds.push(deeplink.id);
                    }
                }
                const arrayDeeplinkLibrarys = await getCardByIds(arrayLibraryIds);
                //添加到集合.
                for (let i=0;i<arrayDeeplinkLibrarys.length;i++){
                    const item = arrayDeeplinkLibrarys[i];
                    if (item && !arrayResult.find(p=>p.id == item?.id)){
                        //不在列表里面的才需要加进来...
                        //是当前类型的才加进来..
                        if (arrayTypes.includes(item.type)){
                            let bAdd = true;
                            if (szTagName){
                                if (szTagName == FILTER_NO_TAGS_NO_TAGS_______){
                                    bAdd = !item.tags || item.tags.length == 0
                                }else{
                                    bAdd = item.tags?.includes(szTagName);
                                }
                            }

                            if (bAdd){
                                arrayResult.push(item);
                            }
                        }
                    }
                }
            }

            if (searchKey){
                searchKey = searchKey.toLowerCase().trim();
                var arrayNewResult = [];
                for (let i=0;i<arrayResult.length;i++){
                    const card = arrayResult[i];
                    if (getSafeString(card.name) && getSafeString(card.name).toLowerCase().indexOf(searchKey) != -1){
                        arrayNewResult.push(card);
                        continue;
                    }
                    if ((arrayTypes.includes('card') && card.type == 'card') || (arrayTypes.includes('journal') && card.type == 'journal')){
                        let szHtml:any = await getCardDoc(card.id);
                        if (szHtml){
                            szHtml = removeHtmlTags(szHtml);
                            if (szHtml.toLowerCase().indexOf(searchKey) != -1){
                                arrayNewResult.push(card);
                            }
                        }
                    }else if (arrayTypes.includes('pdfAnno') && card.type == 'pdfAnno'){
                        if (getSafeString(card.comment)?.toLowerCase()?.includes(searchKey) || getSafeString(card.text)?.toLowerCase()?.includes(searchKey)){
                            arrayNewResult.push(card);
                        }
                    }else if (arrayTypes.includes('cardAnno') && card.type == 'cardAnno'){
                        if (getSafeString(card.comment)?.toLowerCase()?.includes(searchKey) || getSafeString(card.text)?.toLowerCase()?.includes(searchKey)){
                            arrayNewResult.push(card);
                        }
                    }
                    else if (arrayTypes.includes('videoAnno') && card.type == 'videoAnno'){
                        if (getSafeString(card.content)?.toLowerCase()?.includes(searchKey) || getSafeString(card.title)?.toLowerCase()?.includes(searchKey)){
                            arrayNewResult.push(card);
                        }
                    }else if (arrayTypes.includes('audioAnno') && card.type == 'audioAnno'){
                        if (getSafeString(card.content)?.toLowerCase()?.includes(searchKey) || getSafeString(card.title)?.toLowerCase()?.includes(searchKey)){
                            arrayNewResult.push(card);
                        }
                    }
                }

                //带搜索的，再处理一遍标题包含的在前.
                // const arrayIncludeTitles = [];
                // for (let i=0;i<arrayNewResult.length;i++){
                //     const library = arrayNewResult[i];
                //     if (isAnnoType(library.type))continue;
                //     if (library.name?.toLowerCase()?.includes(searchKey)){
                //         arrayIncludeTitles.push(library);
                //     }
                // }
                // const arrayNewNewLibrary:any = [...arrayIncludeTitles];
                // for (let i=0;i<arrayNewResult.length;i++){
                //     const library = arrayNewResult[i];
                //     if (!arrayIncludeTitles.some(p=>p.id == library.id)){
                //         arrayNewNewLibrary.push(library);
                //     }
                // }

                arrayResult = arrayNewResult;
            }
            if (arrayResult.length > 0){
                mLastLibraryKey = arrayResult[0].id;
            }

            resolve(arrayResult);
        }
    })
}

/**
 * 移除所有该标签
 * @param szTagName
 */
export async function removeAllCardTags(szTagName:string){
    if (!szTagName)return;

    const arrayCards = await mCard.toArray();
    for (let i=0;i<arrayCards.length;i++){
        const card = arrayCards[i];
        if (card.tags?.includes(szTagName)){
            const nIndex = card.tags.indexOf(szTagName);
            card.tags.splice(nIndex,1);
            //更新card 的  tag

            updateCard(card);
        }
    }
}

/**
 * 根据标签名称过滤card
 * @param szTagName
 */
export async function getCardByTagName(szTagName:string,szFilterTag:string,szSearchKey:any){
    return new Promise(async (resolve, reject) => {
        const arrayCards:any = await getAllCardList(szSearchKey);
        let arrayLibrarys = (arrayCards.filter(p=>p.tags?.includes(szTagName)));
        if (szFilterTag){
            arrayLibrarys = arrayLibrarys.filter(p=>p.tags.includes(szFilterTag))
        }
        resolve(arrayLibrarys);
    })
}

/**
 * 获取收藏的
 */
export async function getCardFavorList(){
    return mCard.where('isFavirated').equals(1).filter(p=>p.isDeleted == 0).toArray()
}

/**
 * 根据url查询条目是否存在
 * @param szUrl
 */
export async function findItemByUrl(szUrl:any){
    const arrayCards = await mCard.where({type:'webLink',isDeleted:0}).toArray();
    return arrayCards.find(p=>p.fileName == szUrl);
}

/**
 * 复制一个元素
 * @param szOriginId
 * @param szNewId
 */
export function copyNewLibrary(szOriginId:any,szNewId:any){
    getCardById(szOriginId)?.then(res=>{
        res.id = szNewId;
        updateCard(res);
    })
}













































